export default theme => ({
  iconButton: {
    padding: 9,
  },
  tooltipContainer: {
    display: "inline-block",
  },
  sourceSelect: {
    width: '100%'
  }
});
